<template>
  <div>
    <v-skeleton-loader
      v-if="$asyncComputed.examples.updating"
      type="text"
    />
    <div v-else-if="!examples.length">
      No examples
    </div>
    <template v-else>
      <v-tabs v-model="tab">
        <v-tab
          v-for="(example, index) in examples"
          :key="index"
        >
          {{ example.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(example, index) in examples"
          :key="index"
        >
          <v-card>
            <v-card-text>
              <code-editor :source="example.sourceCode" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import {parseVueCode} from '@/helpers/parseSourceCode';
import CodeEditor from '@/components/componentPreview/CodeEditor';

export default {
  name: 'Examples',
  components: {CodeEditor},
  props: {
    componentName: String,
    inlineExamples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: null,
    };
  },
  asyncComputed: {
    async fullExamples() {
      // Template strings inside the import are crashing eslint, so rewrote with concatenation
      // eslint-disable-next-line prefer-template
      const examples = await import('@resman/ui/components/' + this.componentName + '/examples').catch(() => []);

      return Promise.all(Object.keys(examples.default).map(async (name) => {
        const example = {
          name,
          // eslint-disable-next-line prefer-template
          sourceCode: await import('!raw-loader!@resman/ui/components/' + this.componentName + '/examples/' + name + '.vue').then((c) => c.default),
        };

        example.parsedCode = await parseVueCode(example.sourceCode);

        if (example.parsedCode.name) {
          example.name = example.parsedCode.name;
        }

        return example;
      }));
    },
    async examples() {
      const examples = [];
      const {inlineExamples, fullExamples} = this;

      if (inlineExamples.length) {
        const inlineExample = `
<template>
  <div>
${inlineExamples.map(({description: example}) => `    ${example}`).join('\n\n')}
  </div>
</template>

<script>
  export default {};
<\/script>
`.trim();

        let name = 'Inline Example';
        if (inlineExamples.length > 1) {
          name += 's';
        }

        examples.push({
          name,
          sourceCode: inlineExample,
          parsedCode: await parseVueCode(inlineExample),
        });
      }

      if (fullExamples) {
        examples.push(...fullExamples);
      }

      return examples;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
